import { API_BASE } from "./base";

async function handleResponse(res, fallback) {
  const contentType = res.headers.get("content-type") || "";
  let body = null;
  if (contentType.includes("application/json")) {
    body = await res.json().catch(() => null);
  } else {
    const text = await res.text().catch(() => "");
    body = text ? { detail: text } : null;
  }
  if (!res.ok) {
    const message =
      body?.detail?.message ||
      body?.detail ||
      body?.message ||
      fallback ||
      "Request failed";
    const error = new Error(message);
    error.status = res.status;
    error.payload = body;
    throw error;
  }
  return body;
}

export async function marketplaceSignup(payload) {
  const res = await fetch(`${API_BASE}/auth/marketplace/signup`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return handleResponse(res, "Unable to create your MyBoothShare account.");
}

export async function marketplaceLogin(payload) {
  const res = await fetch(`${API_BASE}/auth/marketplace/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return handleResponse(res, "Unable to sign in to MyBoothShare.");
}

export async function requestMarketplaceEmailVerification(email) {
  const res = await fetch(`${API_BASE}/auth/marketplace/email-verification/request`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email }),
  });
  return handleResponse(res, "Unable to send the verification email.");
}

export async function completeMarketplaceEmailVerification(token) {
  const res = await fetch(`${API_BASE}/auth/marketplace/email-verification/complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ token }),
  });
  return handleResponse(res, "Unable to verify your email.");
}

export async function requestMarketplacePasswordReset(identifier) {
  const res = await fetch(`${API_BASE}/auth/marketplace/password-reset/request`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ identifier }),
  });
  return handleResponse(res, "Unable to send the MyBoothShare reset link.");
}

export async function validateMarketplacePasswordReset(token) {
  const params = new URLSearchParams({ token });
  const res = await fetch(
    `${API_BASE}/auth/marketplace/password-reset/validate?${params}`,
    {
      credentials: "include",
    }
  );
  if (res.status === 400) {
    return { valid: false };
  }
  return handleResponse(res, "This MyBoothShare reset link is invalid or expired.");
}

export async function completeMarketplacePasswordReset(payload) {
  const res = await fetch(`${API_BASE}/auth/marketplace/password-reset/complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return handleResponse(res, "Unable to update your MyBoothShare password.");
}

export async function getMarketplaceRenterProfile(token) {
  const res = await fetch(`${API_BASE}/auth/marketplace/me/renter-profile`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: "include",
  });
  return handleResponse(res, "Unable to load your MyBoothShare account.");
}

export async function updateMarketplaceRenterProfile(payload, token) {
  const res = await fetch(`${API_BASE}/auth/marketplace/me/renter-profile`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  return handleResponse(res, "Unable to save your MyBoothShare account.");
}

export async function upgradeMarketplaceAccountToOwner(payload, token) {
  const res = await fetch(`${API_BASE}/auth/marketplace/upgrade-to-owner`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    body: JSON.stringify(payload || {}),
  });
  return handleResponse(res, "Unable to upgrade this account to an owner account.");
}
